import { useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router";
import { Message } from "../components/Page";
import { keyFromHash } from "../lib/resultKey";
import { keepToken } from "../lib/tokens";

/**
 * /continue/{takeId}#k=c.{takeId}.{mac}: a reminder email's link back into an unfinished test, on
 * any device (Oct 31: people who stopped couldn't get back). The key is kept as this browser's
 * token for that take, out of the address bar, and the test opens where they left off (or their
 * results, if they've finished since).
 */
export function Continue() {
  const { takeId = "" } = useParams();
  const navigate = useNavigate();
  const key = keyFromHash(useLocation().hash);
  const valid = !!key && key.startsWith(`c.${takeId}.`);

  useEffect(() => {
    if (!valid || !key) return;
    keepToken(takeId, key);
    navigate(`/take/${takeId}`, { replace: true });
  }, [valid, key, takeId, navigate]);

  if (valid) return null;
  return (
    <Message title="Hmm, this link looks incomplete">
      <p>Try opening the full link from your email again, or sign in with your email and we'll send you a fresh one.</p>
      <p className="mt-6 flex flex-wrap gap-x-6 gap-y-3">
        <a href="/sign-in">Sign in with your email</a>
        <a href="/">Start a new one</a>
      </p>
    </Message>
  );
}
